// external libs
import { ofType } from 'redux-observable'
import Immutable from 'seamless-immutable'
import { from, of, EMPTY } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'

import LeavingScreenActions, { LeavingScreenTypes } from '../redux/LeavingScreenRedux'
import GeneralActions from '../Core/Redux/GeneralRedux'
import { createProductDescriptorValues } from '../Core/Redux/ProductRedux'
import { WEB_TYPES_KEYS } from '../Core/Redux/SettingsRedux'

import packageJson from '../../package.json'

import Api from '../Core/Services/SuriApi'

import type { ImmutableType } from '../Core/Types/ImmutableTypes'

const createFlattenedDataObject = (
  userData: Object & ImmutableType,
  validationErrors: Object & ImmutableType,
  data: Object = Immutable({}),
  prefix: string = '',
) => {
  const prefixArray = prefix ? prefix.split('-') : []
  return Object.keys(userData).reduce((acc, key) => {
    let status = 'ok'
    const errors = validationErrors.getIn([...prefixArray, key])
    const hasError = !!validationErrors.getIn([...prefixArray, key]) && typeof errors !== 'boolean'
    if (hasError) {
      status = 'error'
    }
    // empty has higher priority than error
    const isEmpty = !userData[key] && typeof userData[key] !== 'boolean'
    if (isEmpty) {
      status = 'empty'
    }
    if (typeof userData[key] === 'object' && userData[key] !== null && !Array.isArray(userData[key])) {
      acc = createFlattenedDataObject(userData[key], validationErrors, acc, `${prefix && `${prefix}-`}${key}`)
    } else if (Array.isArray(userData[key])) {
      // array not supported for now
      acc = acc.set(`${prefix && `${prefix}-`}${key}-array`, status)
    } else {
      acc = acc.set(`${prefix && `${prefix}-`}${key}`, status)
    }
    return acc
  }, data)
}

const LeavingScreenEpics = [
  (action$, state$) =>
    action$.pipe(
      ofType(LeavingScreenTypes.SEND_LEAVE_SCREEN_LOG),
      switchMap(() => {
        const {
          leavingScreen: {
            lastLogDateTime,
            productStepCompleted,
            lastLoggedVersion,
            lastInputFocus,
            productStepSubmitted,
          },
        } = state$.value.appData
        const actualDateTime = Date.now()
        // more than week
        if (
          lastLoggedVersion !== packageJson.version ||
          (actualDateTime - lastLogDateTime > 604800000 && !productStepCompleted)
        ) {
          const {
            product: { specification },
            validation: { validationErrors },
            settings: { webType },
          } = state$.value.appData
          const { data, arrayTypes } = state$.value.userData
          const dataToLog = Immutable({
            userData: createFlattenedDataObject(
              createProductDescriptorValues(data, specification, arrayTypes, true, false, false, true),
              validationErrors,
            ),
            dateTime: actualDateTime,
            lastFocus: Array.isArray(lastInputFocus) ? lastInputFocus.join('-') : lastInputFocus,
            submitted: productStepSubmitted,
            website: WEB_TYPES_KEYS[webType],
            googleClientId: Api.getHeader('X-Tracking-googleClientId') || '',
            validationErrors,
          })
          return from([
            LeavingScreenActions.leavingScreenMergeParameters({
              lastLogDateTime: actualDateTime,
              lastLoggedVersion: packageJson.version,
            }),
            GeneralActions.logToStackdriver('leaving-screen', dataToLog),
          ])
        }
        return EMPTY
      }),
      catchError((e) => of(GeneralActions.onChangeRequestFailure(e))),
    ),
]

export default LeavingScreenEpics
